import React, { useState } from 'react';
import { Modal } from 'antd';
import { maths } from '../../../utils';
import './index.less';

const noDrawling = `${process.env.TARGET}static/imgs/no-drawing.jpg`;
/** canvas大小 */
const WIDTH = 700;
const HEIGHT = 500;
let timeRecord = null;
let timer = (time = 0, method = 'block') => {
  timeRecord = setTimeout(() => {
    let dom = document.querySelector('.viewer-tooltip');
    if (dom) {
      dom.style.display = method;
    }
  }, time);
};

export default React.memo(({ visible, imgValue, handleCancel }) => {
  const [error, setError] = React.useState(false);
  const [init, setInit] = React.useState(true);
  const handleError = () => {
    setError(true);
  };

  React.useEffect(() => {
    setError(false);
  }, [visible]);

  const canvasRef = React.useRef();

  const [imgElement, setImgElement] = useState(new Image());
  const [imgX, setImgX] = useState(0);
  const [imgY, setImgY] = useState(0);
  const [imgScale, setImgScale] = useState(1);
  const [mouseDowmPos, setMouseDowmPos] = useState({ x: 0, y: 0 });
  const [mouseDowmFlag, setMouseDowmFlag] = useState(false);

  React.useEffect(() => {
    /** 初始化图片 */
    initImg();
    setInit(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initImg = () => {
    const img = new Image();
    // img.width = WIDTH;
    img.height = HEIGHT;
    img.alt = '加载中...';
    img.src = `${process.env.ASSETS}/${imgValue}`;
    img.onerror = () => {
      img.src = noDrawling;
    };
    img.onload = function() {
      let canvas = canvasRef.current;
      const context = canvasRef.current ? canvasRef.current.getContext('2d') : null;
      let imgX = (canvas.width - img.width) / 2;
      let imgY = (canvas.height - img.height) / 2;
      context.drawImage(
        img, //规定要使用的图像、画布或视频。
        0,
        0, //开始剪切的 x 坐标位置。
        img.width,
        img.height, //被剪切图像的高度。
        imgX,
        imgY, //在画布上放置图像的 x 、y坐标位置。
        img.width * imgScale,
        img.height * imgScale, //要使用的图像的宽度、高度
      );
      setImgX(imgX);
      setImgY(imgY);
      setImgElement(img);
    };
  };

  const drawImage = (imgX, imgY, imgScale) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    console.log(imgElement, 'imgElement');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(
      imgElement, //规定要使用的图像、画布或视频。
      0,
      0, //开始剪切的 x 坐标位置。
      imgElement.width,
      imgElement.height, //被剪切图像的高度。
      imgX,
      imgY, //在画布上放置图像的 x 、y坐标位置。
      imgElement.width * imgScale,
      imgElement.height * imgScale, //要使用的图像的宽度、高度
    );
  };

  /** 图片平移 */
  const handleMouseDown = (event) => {
    event.stopPropagation();
    event.preventDefault(); // 阻止浏览器默认行为，拖动会打开图片
    const { clientX, clientY } = event;
    // 相对于canvas坐标
    const canvas = canvasRef.current;
    const pos = windowToCanvas(clientX, clientY);
    canvas.style.cursor = 'move';
    setMouseDowmFlag(true); // 控制只有在鼠标按下后才会执行mousemove
    setMouseDowmPos({
      x: pos.x,
      y: pos.y,
    });
  };

  const handleMouseMove = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (!mouseDowmFlag) return;
    const canvas = canvasRef.current;
    canvas.style.cursor = 'move';
    const { clientX, clientY } = event;
    let posl = windowToCanvas(clientX, clientY);
    let x = posl.x - mouseDowmPos.x;
    let y = posl.y - mouseDowmPos.y;
    let imgX1 = imgX + x;
    let imgY1 = imgY + y;
    drawImage(imgX1, imgY1, imgScale);
    setImgX(imgX1);
    setImgY(imgY1);
    setMouseDowmPos({
      x: posl.x,
      y: posl.y,
    });
  };

  const handleMouseUp = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const canvas = canvasRef.current;
    canvas.style.cursor = 'default';
    setMouseDowmFlag(false);
  };

  /*坐标转换*/
  const windowToCanvas = (x, y) => {
    let canvas = canvasRef.current;
    let box = canvas.getBoundingClientRect();
    return {
      x: x - box.left - (box.width - canvas.width) / 2,
      y: y - box.top - (box.height - canvas.height) / 2,
    };
  };

  const handleWheelImage = (event) => {
    event.stopPropagation();
    clearTimeout(timeRecord);
    timer();
    let pos = windowToCanvas(event.clientX, event.clientY);
    let n = 1.1;
    let n2 = (1 / 1.1).toFixed(2);
    const bigger = event.deltaY > 0 ? -1 : 1;
    let imgScale1 = imgScale;
    let imgX1 = imgX;
    let imgY1 = imgY;
    if (bigger > 0) {
      imgScale1 *= n;
      imgX1 = imgX * n - pos.x * (n - 1);
      imgY1 = imgY * n - pos.y * (n - 1);
    } else {
      imgScale1 *= n2;
      imgX1 = imgX * n2 + pos.x * (1 - n2);
      imgY1 = imgY * n2 + pos.y * (1 - n2);
    }
    drawImage(imgX1, imgY1, imgScale1);
    setImgX(imgX1);
    setImgY(imgY1);
    setImgScale(imgScale1);
    timer(2000, 'none');
  };

  return (
    <Modal
      visible={visible}
      footer={null}
      width={720}
      destroyOnClose={true}
      wrapClassName="drawing-modal"
      onCancel={handleCancel}
      zIndex="1008"
    >
      {/* <div>
          <img
            src={error ? noDrawling : `${process.env.ASSETS}/uploads/TMdrawings/${projectNo}.jpg`}
            alt="加载中..."
            style={{ width: 650, height: 445 }}
            onError={handleError}
          />
        </div> */}
      <div className="imgArea">
        <canvas
          ref={canvasRef}
          width={WIDTH}
          height={HEIGHT}
          onWheel={handleWheelImage}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          style={{ cursor: 'pointer' }}
        />
        <div className="viewer-tooltip">{maths.mul(imgScale, 100).toFixed(0) + '%'}</div>
      </div>
    </Modal>
  );
});
